// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class QuickFiltersController {
   $scope: any
   quickFilters: any
   constructor($scope: any, quickFilters: any) {
      this.toggleFilter = this.toggleFilter.bind(this)
      this.$scope = $scope
      this.quickFilters = quickFilters
      this.$scope.quickFilters           = this.quickFilters.scope
      this.$scope.toggleFilter           = this.toggleFilter
      this.$scope.getFilterClasses       = this.quickFilters.getFilterClasses
   }

   toggleFilter(filter: any, $event: any) {
      // Fix strange behavior: facet was being clicked twice every time checkmark was clicked
      if ($event?.target?.className === 'checkmark') {
         $event.preventDefault()
      }

      return this.quickFilters.toggle(filter)
   }
}

QuickFiltersController.$inject = ['$scope', 'quickFiltersService']

angular.module('summonApp.controllers')
   .controller('QuickFiltersCtrl', QuickFiltersController)
